export type TBannerThemes = 'blueDark' | 'light' | 'grayDark';

const bannerThemes: Record<TBannerThemes, string> = {
  blueDark: 'bg-[#082F63] text-white',
  light: 'bg-white text-[#1C2024]',
  grayDark: 'bg-[#1C2024] text-white',
};

export const getBannerBackgroundColor = (theme: TBannerThemes): string => {
  switch (theme) {
    case 'light':
      return '#FFFFFF';
    case 'blueDark':
      return '#082F63';
    case 'grayDark':
      return '#1C2024';
    default:
      return '#FFFFFF';
  }
};

export const getButtonColor = (theme: TBannerThemes): string => {
  switch (theme) {
    case 'light':
      return '#1C2024';
    case 'blueDark':
    case 'grayDark':
      return '#FFFFFF';
    default:
      return '#1C2024';
  }
};

export const getUrlLinkColor = (theme: TBannerThemes): string => {
  switch (theme) {
    case 'light':
      return '[&_a]:text-[#0F6FDE]';
    case 'blueDark':
    case 'grayDark':
      return '';
    default:
      return '';
  }
};

export default bannerThemes;